import * as tslib_1 from "tslib";
import React from 'react';
import classNames from 'classnames';
import FormGroup from '../Form/FormGroup';
import { toggleItem } from '../utils/arrays';
import { removeUndefinedProperties } from '../utils/objects';
import Checkbox from './Checkbox';
import without from 'lodash/without';
import union from 'lodash/union';
function getCheckboxValue(props) {
    if (props.value) {
        return props.value;
    }
    if (props.children && typeof props.children === 'string') {
        // tslint:disable-next-line:no-any
        return props.children;
    }
    return undefined;
}
/**
 * 复选框组组件。不指定value属性时，此组件为非受控状态，自身维护选中状态。
 */
var CheckboxGroup = /** @class */ (function (_super) {
    tslib_1.__extends(CheckboxGroup, _super);
    function CheckboxGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.isControlled = false;
        /**
         *处理全选
         *
         * @private
         * @memberof CheckboxGroup
         */
        _this.onSelectAllClick = function (event) {
            var value = _this.isControlled ? _this.props.value : _this.state.value;
            event.stopPropagation();
            var items = _this.getItemValues();
            if (_this.selectedAll) {
                if (!_this.isControlled) {
                    _this.setState({
                        value: without.apply(void 0, [value].concat(items)),
                    });
                }
                if (_this.props.onChange) {
                    _this.props.onChange(without.apply(void 0, [value].concat(items)));
                }
            }
            else {
                if (!_this.isControlled) {
                    _this.setState({
                        value: union(value.concat(items)),
                    });
                }
                if (_this.props.onChange) {
                    _this.props.onChange(union(value.concat(items)));
                }
            }
        };
        _this.onSelectAllChange = function (event) {
            event.stopPropagation();
        };
        _this.onCheckboxChange = _this.onCheckboxChange.bind(_this);
        _this.isControlled = typeof props.value !== 'undefined';
        if (!_this.isControlled) {
            _this.state = {
                value: props.value || [],
            };
        }
        return _this;
    }
    /**
     * 处理选中的值
     *
     * @private
     * @param {React.MouseEvent<HTMLElement>} event
     * @param {T} checkboxValue
     * @returns
     * @memberof CheckboxGroup
     */
    CheckboxGroup.prototype.onCheckboxChange = function (event, checkboxValue) {
        var _a = this.props.value, valueProp = _a === void 0 ? [] : _a;
        var value = toggleItem(this.isControlled ? valueProp : this.state.value, checkboxValue);
        if (this.props.readOnly) {
            return;
        }
        if (!this.isControlled) {
            this.setState({
                value: value,
            });
        }
        if (this.props.onChange) {
            event.stopPropagation();
            this.props.onChange(value);
        }
    };
    /**
     *获取所有子元素的值
     *
     * @private
     * @returns {any[]}
     * @memberof CheckboxGroup
     */
    CheckboxGroup.prototype.getItemValues = function () {
        return React.Children.map(this.props.children, function (item) {
            return item && React.isValidElement(item) && getCheckboxValue(item.props);
        }).filter(Boolean);
    };
    Object.defineProperty(CheckboxGroup.prototype, "selectedAll", {
        get: function () {
            var items = this.getItemValues();
            var newValue = this.isControlled ? this.props.value : this.state.value;
            return newValue && items.every(function (_) { return newValue.indexOf(_) !== -1; });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * 渲染全选复选框
     *
     * @private
     * @returns
     * @memberof CheckboxGroup
     */
    CheckboxGroup.prototype.renderSelectAll = function () {
        var value = this.isControlled ? this.props.value : this.state.value;
        var selectAll = this.props.enableSelectAll && (React.createElement(Checkbox, { indeterminate: value && value.length > 0 && !this.selectedAll, onClick: this.onSelectAllClick, checked: this.selectedAll, onChange: this.onSelectAllChange, readOnly: this.props.readOnly, disabled: this.props.disabled }, "\u5168\u9009"));
        return selectAll;
    };
    CheckboxGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, valueProp = _a.value, labelPosition = _a.labelPosition, disabled = _a.disabled, readOnly = _a.readOnly, dense = _a.dense, onBlur = _a.onBlur, onFocus = _a.onFocus, color = _a.color, onChange = _a.onChange, rest = tslib_1.__rest(_a, ["children", "value", "labelPosition", "disabled", "readOnly", "dense", "onBlur", "onFocus", "color", "onChange"]);
        var value = this.isControlled ? valueProp : this.state.value;
        return (React.createElement(FormGroup, tslib_1.__assign({}, rest, { className: classNames('sinoui-checkbox-group', this.props.className) }),
            this.renderSelectAll(),
            React.Children.map(children, function (checkbox) {
                if (React.isValidElement(checkbox)) {
                    var checkboxProps = removeUndefinedProperties({
                        checked: value.indexOf(getCheckboxValue(checkbox.props)) !== -1,
                        onChange: function (e, v) {
                            if (checkbox.props.onChange) {
                                checkbox.props.onChange(e, v);
                            }
                            _this.onCheckboxChange(e, checkbox.props.value);
                        },
                        labelPosition: labelPosition,
                        disabled: checkbox.props.disabled || disabled,
                        readOnly: readOnly,
                        dense: dense,
                        onBlur: !readOnly && onBlur,
                        onFocus: !readOnly && onFocus,
                        color: color,
                    });
                    return React.cloneElement(checkbox, checkboxProps);
                }
                return checkbox;
            })));
    };
    CheckboxGroup.defaultProps = {
        columns: 3,
    };
    return CheckboxGroup;
}(React.Component));
export default CheckboxGroup;
//# sourceMappingURL=CheckboxGroup.js.map